import { Link } from "react-router-dom";

export default function FinalCTA() {
  return (
    <section className="relative py-32 bg-slate-900 text-white overflow-hidden">

      {/* Subtle Blue Atmospheric Glow */}
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[700px] h-[400px] bg-gradient-to-r from-blue-500/20 via-blue-400/10 to-transparent blur-3xl"></div>

      <div className="relative max-w-4xl mx-auto px-6 md:px-12 text-center">

        <h2 className="text-3xl md:text-4xl font-semibold tracking-tight mb-6">
          Let’s Build Reliable Systems Together
        </h2>

        <p className="text-slate-300 text-lg leading-relaxed mb-10 max-w-2xl mx-auto">
          I design and build scalable backend systems focused on performance,
          clean architecture, and long-term maintainability.
        </p>

        <Link
          to="/contact"
          className="
            inline-block
            bg-white text-slate-900
            px-10 py-4
            rounded-full
            font-medium
            transition duration-300
            hover:-translate-y-1
            hover:shadow-xl
            hover:shadow-blue-500/30
          "
        >
          Start a Conversation →
        </Link>

      </div>
    </section>
  );
}